import React, { Component } from 'react';
import gql from 'graphql-tag';
import client from '../client';


export const LoggedInContext = React.createContext(false);
export const LogOutContext = React.createContext(() => ({}));
export const AuthFunctionsContext = React.createContext({});

export const IsLoggedIn = LoggedInContext.Consumer;
export const LogOut = LogOutContext.Consumer;
export const AuthFunctions = AuthFunctionsContext.Consumer;

export const getAuthToken = () => localStorage.getItem('authToken');

class Auth extends Component {
  constructor() {
    super();
    this.authTokenFlag = 'authToken';
    this.authToken = localStorage.getItem(this.authTokenFlag);
    this.state = { authToken: this.authToken };
    client.query({ query: gql`{ currentUser { id } }` }).catch((error) => {
      if (error && this.isAuthenticated()) {
        if (error.message.includes('Invalid token')) {
          console.warn('logout');
          this.logout();
        }
      }
    });
  }

  async requestOtp({ email }) {
    return client.mutate({
      mutation: gql`
    mutation requestOtp($email: String!) {
      requestOtp(email: $email)
    }`,
      variables: { email },
    });
  }

  async loginWithOtp({ email, code }) {
    const { data: { loginWithOtp: token } } = await client.mutate({
      mutation: gql`
    mutation loginWithOtp($email: String!, $code: String!) {
      loginWithOtp(email: $email, code: $code)
    }`,
      variables: { email, code },
    });
    this.authToken = token;
    localStorage.setItem(this.authTokenFlag, token);
    client.resetStore();
    this.setState({ authToken: token });
  }

  async changePassword({ token, password }) {
    const { data: { changePassword: loginToken } } = await client.mutate({
      mutation: gql`
    mutation changePassword($token: String!, $password: String!) {
      changePassword(token: $token, password: $password)
    }`,
      variables: { token, password },
    });
    this.authToken = loginToken;
    localStorage.setItem(this.authTokenFlag, loginToken);
    client.resetStore();
    this.setState({ authToken: loginToken });
  }

  async resetPassword({ email }) {
    return await client.mutate({
      mutation: gql`
    mutation resetPassword($email: String!) {
      resetPassword(email: $email)
    }`,
      variables: { email },
    });
  }

  logout() {
    this.authToken = null;
    localStorage.removeItem(this.authTokenFlag);
    client.resetStore();
    this.setState({ authToken: null });
  }

  isAuthenticated() {
    return this.authToken !== null;
  }

  getAuthToken() {
    return this.authToken;
  }

  render() {
    return (
      <LoggedInContext.Provider value={!!this.state.authToken}>
        <LogOutContext.Provider value={this.logout.bind(this)}>
          <AuthFunctionsContext.Provider value={{
            logout: this.logout.bind(this),
            resetPassword: this.resetPassword.bind(this),
            changePassword: this.changePassword.bind(this),
            requestOtp: this.requestOtp.bind(this),
            loginWithOtp: this.loginWithOtp.bind(this),
          }}
          >
            {this.props.children}
          </AuthFunctionsContext.Provider>
        </LogOutContext.Provider>
      </LoggedInContext.Provider>
    );
  }
}


export { Auth as AuthProvider };



// WEBPACK FOOTER //
// ./src/auth/Auth.js